import React from "react";
import "../../styles/PhoneFrame.css";

export default function PhoneFrame({ children }) {
  return (
    <div className="phone-container">
      <div className="phone-notch">
        <div className="notch-camera"></div>
      </div>

      <div className="phone-screen">{children}</div>

      <div className="phone-nav">
        <div className="nav-btn">⟵</div> {/* Back */}
        <div className="nav-btn">◯</div> {/* Home */}
        <div className="nav-btn">▢</div> {/* Recent */}
      </div>
    </div>
  );
}
